import Vue from 'vue'

export default {
  store (data) {
    return Vue.http.post('/location_change_requests', data)
  }

}
